import React from 'react';
import { SpeechToTextLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiSummarizerConfig } from '@/data/landingConfig/landingAiSummarizerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiSummarizer } from './schemaObject';

interface Props {}
const AiSummarizer: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiSummarizer} />
			<SpeechToTextLandingTemplate
				data={landingAiSummarizerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelSpeechToText()}
			/>
		</>
	);
};

export default AiSummarizer;
